<script>
import AwardPointPopup from '@/components/activity/AwardPointPopup.vue';
import AwardPopup from '@/components/activity/AwardPopup.vue';
import AwardCouponPopup from '@/components/activity/AwardCouponPopup.vue';

export default {
  components: {
    AwardPointPopup,
    AwardPopup,
    AwardCouponPopup,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
    awardType: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  render(h) {
    let component = '';
    switch (this.awardType) {
      case 0:
      case 1:
      case 4:
        component = 'AwardPopup';
        break;
      case 2:
      case 3:
        component = 'AwardPointPopup';
        break;
      case 5:
        component = 'AwardCouponPopup';
        break;
      default:
        break;
    }

    return h(component, { on: this.$listeners, props: this.$props });
  },
};
</script>
